import React from 'react';
import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import { Wrapper } from '@components';
import WhereToBuyCard from '@components/molecules/WhereToBuyCard';
import patternPurple from '@assets/pattern-purple.svg';

const WhereToBuyBlock = ({ data: { title, description, whereToBuyCards } }) => {
  return (
    <Box
      bgImage={patternPurple}
      bgRepeat="repeat"
      py={{ base: `12`, md: `28` }}>
      <Wrapper medium>
        <Heading
          fontSize={{ base: `4xl`, md: `7xl` }}
          as="h1"
          textTransform="uppercase"
          color="purple.600"
          fontWeight="900"
          fontStyle="italic">
          {title}
        </Heading>
        <Box color="purple.600" fontSize="md" fontWeight="600" mb="10">
          {description}
        </Box>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing={{ base: `6`, md: `10` }}>
          <WhereToBuyCard whereToBuyCards={whereToBuyCards} />
        </SimpleGrid>
      </Wrapper>
    </Box>
  );
};

export default WhereToBuyBlock;
